export default __webpack_public_path__ + "static/media/rightnow.134a852d.jpg";